import { withStyles } from '@material-ui/core';
import { getCustomerAddress, getConsigneeAddress, getShipperAddress } from '../../../ShipmentsView/utils';

const styles = (theme) => ({
  addressCell: {
    fontSize: theme.dispatchCardTextFontSize,
    wordBreak: 'break-all',
    color: theme.printTableLabel
  }
});

const ConsigneeAddress = ({ data, classes, fieldCallBackFn = 'getCustomerAddress' }) => {
  const fnMap = {
    "getCustomerAddress": getCustomerAddress,
    "getConsigneeAddress": getConsigneeAddress,
    "getShipperAddress": getShipperAddress
  };
  return (
    <div className={classes.addressCell}>
      {fnMap[fieldCallBackFn]({ data })}
    </div>
  );
};

export default withStyles(styles)(ConsigneeAddress);
